import is_server from './is_server'
export default function isMobile() {
	if (!is_server()) {
		return window.innerWidth <= 576
	}
	return false
}
